module.exports = __webpack_public_path__ + "fonts/Marianne-Regular.fb85e4b.woff";